import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import {cls, Row, Column, Button,} from '../../packages/components';
import './styles/modalLimitAttempts.scss';
import Translator from '../../requests/apa/Translator';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY, LIMITEINTENTOSDIARIOS, MODALLIMITEINTENTOSDIARIOS } from '../../AAFPlayer/constants';
import {GA4} from '../../utils/trackers/GA4';
import Utils from '../../utils/Utils';
import { resumePlayer } from '../../2FA/callbacks';

const MAIN_CLASSNAME = 'modal-limit-attempts';
const MAIN_TEXTNAME_CLASSNAME = 'aaf_text-limit-attempts';
const TEXT_KEYS = {
  title: 'Alerta_2FATelmex_LimiteIntentos_TextoTitulo',
  oneText: 'Alerta_2FATelmex_LimiteIntentos_TextoMensaje1',
  secondText1: 'Alerta_2FATelmex_LimiteIntentos_TextoMensaje2_Parte1',
  secondText2: 'Alerta_2FATelmex_LimiteIntentos_TextoMensaje2_Parte2',
  secondText3: 'Alerta_2FATelmex_LimiteIntentos_TextoMensaje2_Parte3',
  helpTitle: 'Alerta_2FATelmex_TextoTituloAyuda',
  helpText1: 'Alerta_2FATelmex_LimiteIntentos_TextoAyuda1',
  helpText2: 'Alerta_2FATelmex_LimiteIntentos_TextoAyuda2',
  button: 'Alerta_2FATelmex_TextoBotonPrimario_Aceptar'
};

class AAFModalLimitAttempts extends Component  {
  constructor(props) {
    super(props);

    const dataBuyconfirm = JSON.parse(localStorage.getItem('buyConfirmData'));
    this.getParamsMetrics2FA = Utils.getParamsMetricsModals2FA(props.dataMetrics2FA, LIMITEINTENTOSDIARIOS, props.history.location.pathname, MODALLIMITEINTENTOSDIARIOS, dataBuyconfirm && dataBuyconfirm.phone, dataBuyconfirm && dataBuyconfirm.mail);
  }

  componentDidMount() {
  }
    
  componentWillUnmount() {
  }

  sendGA4Metric(){
      const gA4 = new GA4();
      gA4.sendMetrics2FA(this.getParamsMetrics2FA, LIMITEINTENTOSDIARIOS);
  }

  handleClick = () => {
    this.sendGA4Metric();
    resumePlayer()
    this.closeModal();
  };

  closeModal = () => {
    const { handleClose = () => {} } = this.props;
    handleClose();
  };

  callbackWhenBack = () => {
    resumePlayer()
  }

  getContentText = (key) => {
    const translation = Translator.get(key)
    if(translation === "" || translation === undefined){
      return key
    } else if(translation === null){
      return '\u00A0'
    }else{
      return translation
    } 
  }

  cutText = (text, characters) => {
    const cut = characters;
    let indexCut = text.lastIndexOf(' ', cut);
    if (indexCut === -1) {
      return(
        <Column lg={12}>
          <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>
            {text}
          </p>
        </Column>
      )
    }      

    const firstText = text.slice(0, indexCut);
    const secondText = text.slice(indexCut + 1);
  
    return(
      <Column lg={12}>
        <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>
          {firstText} <br></br> {secondText}
        </p>
      </Column>
    )
  }

  render(){
    return (
      <ModalWrapper className="aaf_app_modal-limit-attempts" callbackWhenBack={this.callbackWhenBack}>
        <div className={`${MAIN_CLASSNAME} FullHD`}>
          <Row className={cls(`${MAIN_CLASSNAME} divTitle`)}>
              <Column lg={12}>
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} title`)}>
                  {this.getContentText(TEXT_KEYS.title)}
                </p>
              </Column>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divOneText`)}>
            {this.cutText(this.getContentText(TEXT_KEYS.oneText), 35)}
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divSecondText`)}>
            <div>
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} secondText`)}>{this.getContentText(TEXT_KEYS.secondText1)}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{this.getContentText(TEXT_KEYS.secondText2)}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} secondText`)}>{this.getContentText(TEXT_KEYS.secondText3)}</p>
            </div>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divButton`)}>
              <Button
              activate
              id="okButton"
              type="button"
              variant="primary"
              className={cls(`${MAIN_TEXTNAME_CLASSNAME} primaryButton focusable`)}
              onClick={this.handleClick}
              >
              {this.getContentText(TEXT_KEYS.button)}
              </Button>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divTitleHelp`)}>
            <Column lg={12}>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} titleHelp`)}>
                {this.getContentText(TEXT_KEYS.helpTitle)}
              </p>
            </Column>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divTextHelp`)}>
            <Column lg={12}>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
                {this.getContentText(TEXT_KEYS.helpText1)}
              </p>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
                {this.getContentText(TEXT_KEYS.helpText2)}
              </p>
            </Column>
          </Row>
        </div>
      </ModalWrapper>
    );
  }
};

AAFModalLimitAttempts.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

AAFModalLimitAttempts.defaultProps = {
  handleClose: () => {},
};

export default withOnClose(AAFModalLimitAttempts);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalLimitAttempts2FA.jsx